import Image from 'next/image'

import { atomMeditating } from '@ui/assets'
import { Seo } from '@ui/components/seo'
import { HeroBasic } from '@ui/hero'

export function MainBlockNotFound() {
  return (
    <>
      <Seo
        title="Page Not Found"
        description="The page you are looking for does not exist."
      />
      <div className="flex flex-col items-center justify-center">
        <HeroBasic
          title="Page Not Found"
          description="Oops! Looks like you're a little lost. The page you're looking for is not available."
        />
        <div className="relative flex h-[300px] w-full items-center justify-center pb-20 md:h-[350px]">
          <Image
            alt="ATM atom"
            src={atomMeditating}
            className="absolute w-[600px]"
          />
        </div>
      </div>
    </>
  )
}
